import { Box, BoxProps, Tbody as CTBody } from '@chakra-ui/react';
import React from 'react';

export const TBody = ({ children, sx, ...props }: BoxProps) => (
  <CTBody as={Box} sx={{ display: 'table-row-group', ...sx }} {...props}>
    {children}
  </CTBody>
);
